export default "__VITE_ASSET__BacBAFgr__"